import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
  open: boolean;
  nextOpenTime?: number | null;
}

const initialState: IState = {
  open: false,
  nextOpenTime: null
};

const limitFinishedSlice = createSlice({
  name: 'limit-modal',
  initialState,
  reducers: {
    setLimitOpen: (state, action: PayloadAction<IState>) => {
      state.open = action.payload.open;
      if (action.payload.nextOpenTime !== undefined) {
        state.nextOpenTime = action.payload.nextOpenTime;
      }
    }
  }
});

export const { setLimitOpen } = limitFinishedSlice.actions;
export const limitFinishedModalReducer = limitFinishedSlice.reducer;
